export default __webpack_public_path__ + "static/media/lowLevelDesign.8a105a7c.svg";